const MY_AUDIENCE_STATUS_ACTIVE = 'ACTIVE';
export const filterActiveAudiences = ({ status }) => status === null || status === MY_AUDIENCE_STATUS_ACTIVE;
